import { CheckBox } from "@core/components/alt-ui/controls";
import { FieldControl } from "../field-control";
import { Formatter } from "@/utils/formatter";
import { Uuid } from "@/utils/uuid";

export class CheckBoxFieldControl extends FieldControl<CheckBox> {
    protected convert(): CheckBox {
        const control = new CheckBox();
        control.id = `${this.field.id}_${Uuid.short()}`;
        control.text = this.field.title ?? "";
        control.help = this.field.description ?? "";
        control.validation = this.validationToString(this.field.validation);
        control.value = this.isTrue(this.field.default ?? false);
        return control;
    }

    public get value(): any {
        return this.control.value;
    }

    public set value(value: any) {
        this.control.value = this.isTrue(value);
    }

    private isTrue(value: any): boolean {
        return value === true || value === "true";
    }

    public getValueFormatted(): string {
        return Formatter.boolean(this.value);
    }
}
